
import '@/icons';
import Vue from 'vue';
import MarkdownRenderer from '@/components/blocks/markdown-renderer.vue';
import FAQ from '@/store/modules/support/faq';

export default Vue.extend({
  name: 'SupportView',
  components: {
    MarkdownRenderer,
  },
  data() {
    return {
      expandedFaq: 0 as number | string,
    };
  },
  computed: {
    isInNorthAmerica(): boolean {
      return this.$store.getters['user/profile/isInNorthAmerica'];
    },
    isInCA(): boolean {
      return this.$store.getters['user/profile/isInCA'];
    },
    faqList(): FAQ[] {
      return this.$store.state.support.faqList;
    },
    showFAQs(): boolean {
      return this.faqList.length > 0;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.hash) {
          let id: number = 0;

          if (to.hash.substr(0, 5) === '#faq-') {
            id = Number(to.hash.substr(5));
          }

          if (Number.isNaN(id) || id < 1) {
            return;
          }

          const faq = this.faqList.find((item) => item.id === id || item.id === String(id));

          if (faq) {
            this.expandedFaq = faq.id;
          }
        }
      },
    },
  },
});
